var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBancaires(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 24,
    viewBox: "0 0 56 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.8111 7.91739C55.8111 7.41282 55.7131 6.9204 55.517 6.44015C55.3271 5.98421 55.0453 5.5769 54.6716 5.22431C54.2612 4.83524 53.814 4.56168 53.3239 4.40362C52.8338 4.25164 52.1661 4.17261 51.3268 4.17261H40.006V7.91739V11.6622H51.3207C52.16 11.6622 52.8277 11.5831 53.3178 11.4312C53.8079 11.2792 54.2551 11.0056 54.6655 10.6165C55.0392 10.264 55.321 9.85665 55.5109 9.40071C55.7131 8.9083 55.8111 8.41588 55.8111 7.91739Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8111 16.41C55.8111 15.9054 55.7131 15.413 55.517 14.9267C55.3271 14.4647 55.0453 14.0634 54.6716 13.7048C54.2612 13.3157 53.814 13.0421 53.3239 12.8841C52.8338 12.726 52.1661 12.6531 51.3268 12.6531H40.006V16.4039V20.1548H51.3207C52.16 20.1548 52.8277 20.0758 53.3178 19.9238C53.8079 19.7657 54.2551 19.4982 54.6655 19.1031C55.0392 18.7505 55.321 18.3432 55.5109 17.8812C55.7131 17.407 55.8111 16.9146 55.8111 16.41Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9891 11.6621C38.7624 6.81696 35.2522 3.69226 29.7327 3.69226C24.0355 3.69226 20.4641 7.03581 20.4641 12.1666C20.4641 17.4616 24.1764 20.641 29.7327 20.641C35.2951 20.641 38.7686 17.4981 38.9891 12.653H30.0268V11.656H38.9891V11.6621Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancaires);
export default __webpack_public_path__ + "static/media/bancaires.4872f588.svg";
export { ForwardRef as ReactComponent };